import Vue from "vue";
import Vuex from "vuex";
import User from "./modules/UserVuex";
import App from "./modules/AppVuex";
import Notification from "./modules/NotificationVuex";
import Execution from "./modules/ExecutionVuex";
import Department from './modules/DepartmentVuex';
import Category from './modules/CategoryVuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    App,
    User,
    Notification,
    
    Execution,
    Department,
    Category
  }
});

export default store;
